// @ts-ignore
window.addedLibs = window.addedLibs || {};

function loadDependenciesFirst (deps, onceLoaded) {
	'use strict';
	var aDep;

	if (!deps.length) return onceLoaded();

	aDep = deps[0];
	deps.shift();
	loadLibrary(aDep, null, function () {
		loadDependenciesFirst(deps, onceLoaded);
	});
}

function loadLibrary (file, lib, onceLoaded) {
	'use strict';
	jQuery.getScript(file, function () {
		if (window[lib + 'Dependencies']) {
			loadDependenciesFirst(window[lib + 'Dependencies'], onceLoaded);
		} else {
			onceLoaded();
		}
	});
}

function checkLib (lib, path, onceLoaded) { // eslint-disable-line no-unused-vars
	'use strict';
	// @ts-ignore
	var base = window.baseURL || '/mrcjava';

	// @ts-ignore
	if (window.addedLibs[lib]) {
		// Library loaded already through file manager
		// @ts-ignore
		window.addedLibs[lib]++;
		onceLoaded();
	} else if (typeof window[lib] === 'function') {
		// Library loaded already through page
		// @ts-ignore
		window.addedLibs[lib] = 1;
		onceLoaded();
	} else {
		// Need to load library
		loadLibrary(base + '/' + (path ? path + '/' : '') + lib + '.js', lib, onceLoaded);
		// Add to addedLibs
		// @ts-ignore
		window.addedLibs[lib] = 1;
	}
}
